module.exports = __webpack_public_path__ + "img/graphic-2.cfb69fd5.png";